import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  // Form Login
  public formLogin: FormGroup;
  public formLoginSubmit = false;
  public formLoginError  = false;
  public  formLoginActive = true;

  constructor(    private route: ActivatedRoute,
                  private router: Router,
                  private auth: AuthService) { }

  ngOnInit() {
    this.formLogin = new FormGroup({
      'username': new FormControl('', [Validators.required]),
      'password': new FormControl('', [Validators.required])
    });

  }

  signInWithEmail() {
    this.auth.signInRegular(this.formLogin.value.username + '@lascumbres.edu.ar', this.formLogin.value.password)
      .then((res) => {
        this.router.navigate(['home']);
      })
      .catch((err) => {
        console.log('error: ' + err);
        this.formLoginError = true;
      });
  }

}
